import React from "react";
import Highlights from "../Highlights";

export default function HighlightsBlock({ id, type, ...content }) {
  return <Highlights content={content} />;
}
